import type { SobreimpresoTextAlign, SobreimpresoTextbox } from './types';
import { Fill } from '../../shared/utils/fill';
import { resizeSobreimpresoHeight } from './render';

const markDirty = (s: SobreimpresoTextbox): void => {
  s.dirty = true;
  s.canvas?.requestRenderAll();
};

export const getSobreimpresoText = (s: SobreimpresoTextbox): string => s.text ?? '';

export const setSobreimpresoText = (s: SobreimpresoTextbox, text: string): void => {
  s.set({ text });
  resizeSobreimpresoHeight(s);
};

export const getSobreimpresoFill = (s: SobreimpresoTextbox): Fill => s.sobreimpreso.fill;

export const setSobreimpresoFill = (s: SobreimpresoTextbox, fill: Fill): void => {
  s.sobreimpreso.fill = fill;
  markDirty(s);
};

export const getSobreimpresoTextFill = (s: SobreimpresoTextbox): string => (s.fill as string) ?? '';

export const setSobreimpresoTextFill = (s: SobreimpresoTextbox, color: string): void => {
  s.set('fill', color);
  s.canvas?.requestRenderAll();
};

export const getSobreimpresoFontFamily = (s: SobreimpresoTextbox): string => s.fontFamily ?? '';

export const setSobreimpresoFontFamily = (s: SobreimpresoTextbox, value: string): void => {
  s.set('fontFamily', value);
  resizeSobreimpresoHeight(s);
};

export const getSobreimpresoFontSize = (s: SobreimpresoTextbox): number => s.fontSize ?? 16;

export const setSobreimpresoFontSize = (s: SobreimpresoTextbox, value: number): void => {
  s.set('fontSize', value);
  resizeSobreimpresoHeight(s);
};

export const getSobreimpresoFontWeight = (s: SobreimpresoTextbox): number | string => s.fontWeight ?? 400;

export const setSobreimpresoFontWeight = (s: SobreimpresoTextbox, value: number | string): void => {
  s.set('fontWeight', value);
  resizeSobreimpresoHeight(s);
};

export const getSobreimpresoTextAlign = (s: SobreimpresoTextbox): SobreimpresoTextAlign =>
  (s.textAlign as SobreimpresoTextAlign) ?? 'left';

export const setSobreimpresoTextAlign = (s: SobreimpresoTextbox, value: SobreimpresoTextAlign): void => {
  s.set('textAlign', value);
  markDirty(s);
};

export const getSobreimpresoBorderRadius = (s: SobreimpresoTextbox): number => s.sobreimpreso.borderRadius;

export const setSobreimpresoBorderRadius = (s: SobreimpresoTextbox, value: number): void => {
  s.sobreimpreso.borderRadius = value;
  markDirty(s);
};

export const getSobreimpresoStroke = (s: SobreimpresoTextbox): string => s.sobreimpreso.stroke;

export const setSobreimpresoStroke = (s: SobreimpresoTextbox, color: string): void => {
  s.sobreimpreso.stroke = color;
  markDirty(s);
};

export const getSobreimpresoStrokeWidth = (s: SobreimpresoTextbox): number => s.sobreimpreso.strokeWidth;

export const setSobreimpresoStrokeWidth = (s: SobreimpresoTextbox, value: number): void => {
  s.sobreimpreso.strokeWidth = value;
  markDirty(s);
};

export const getSobreimpresoPaddingX = (s: SobreimpresoTextbox): number => s.sobreimpreso.paddingX;

export const setSobreimpresoPaddingX = (s: SobreimpresoTextbox, value: number): void => {
  s.sobreimpreso.paddingX = value;
  s.initDimensions();
  resizeSobreimpresoHeight(s);
};

export const getSobreimpresoPaddingY = (s: SobreimpresoTextbox): number => s.sobreimpreso.paddingY;

export const setSobreimpresoPaddingY = (s: SobreimpresoTextbox, value: number): void => {
  s.sobreimpreso.paddingY = value;
  resizeSobreimpresoHeight(s);
};

export const getSobreimpresoMinHeight = (s: SobreimpresoTextbox): number => s.sobreimpreso.minHeight;

export const setSobreimpresoMinHeight = (s: SobreimpresoTextbox, value: number): void => {
  s.sobreimpreso.minHeight = value;
  resizeSobreimpresoHeight(s);
};

export const getSobreimpresoWidth = (s: SobreimpresoTextbox): number => s.width ?? 0;

export const setSobreimpresoWidth = (s: SobreimpresoTextbox, value: number): void => {
  s.set({ width: Math.max(10, value) });
  s.initDimensions();
  resizeSobreimpresoHeight(s);
};
